"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.error.failedToLoad': 'Impossibile caricare le conversazioni',
    'conversations.error.failedToDelete': 'Impossibile eliminare la conversazione',
    'conversations.error.failedToToggleFavorite': 'Impossibile cambiare lo stato dei preferiti',
};
